//
// Module for Subscription Defaults Edit view
//
rs.module("fund/configuration/subscriptiondefaults/edit",

    [ "common/visibility" ],

    function (visibility) {

        // Initialize the module
        function initialize(jsSelectors, backendUrl) {
            var subscriptionDefaultsForm = $.js(jsSelectors.subscriptionDefaultsForm);
            var eventSelect = subscriptionDefaultsForm.js(jsSelectors.eventSelect);
            var eventDescription = subscriptionDefaultsForm.js(jsSelectors.eventDescription);
            var intervalTextBox = subscriptionDefaultsForm.js(jsSelectors.intervalTextBox);
            var intervalRequired = subscriptionDefaultsForm.js(jsSelectors.intervalRequired);

            eventSelect.change(onEventChanged);
            onEventChanged();

            function onEventChanged() {
                $.getJSON(backendUrl, { eventId: eventSelect.val() }).done(function (data) {
                    eventDescription.text(data.description);
                    intervalRequired.val(data.intervalRequiredFlag);

                    if (!data.intervalRequiredFlag) {
                        intervalTextBox.val("");
                        intervalTextBox.clearErrors();
                    }
                    intervalTextBox.prop("disabled", !data.intervalRequiredFlag);
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);